// styles
import { colors, greys } from "@styles/color.styles";
import { fontFamilySans } from "@styles/type.styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

// components
import { header as tipHeader, body as tipBody } from "@components/tutorial-tip/TutorialTip.styles";

export const event: CSSProperties = {
  flexDirection: "column",
  overflow: "hidden",
  borderRadius: 8,
  cursor: "pointer",
  width: "100%",
  height: "100%",
  color: greys.white,
  transition: "background-color 250ms",
  border: `1px solid ${greys.white}`,
  padding: "6px 8px",
};

export const eventDisabled: CSSProperties = {
  ...event,
  color: colors.birch.darkest,
  backgroundImage: `
    repeating-linear-gradient(to right, ${colors.birch.standard} 0%, ${colors.birch.standard} 75%, transparent 25%, transparent 100%),
    repeating-linear-gradient(to right, ${colors.birch.standard} 0%, ${colors.birch.standard} 75%, transparent 25%, transparent 100%),
    repeating-linear-gradient(to bottom, ${colors.birch.standard} 0%, ${colors.birch.standard} 75%, transparent 25%, transparent 100%),
    repeating-linear-gradient(to bottom, ${colors.birch.standard} 0%, ${colors.birch.standard} 75%, transparent 25%, transparent 100%)
  `,
  backgroundPosition: "left top, left bottom, left top, right top",
  backgroundRepeat: "repeat-x, repeat-x, repeat-y, repeat-y",
  backgroundSize: "8px 2px, 8px 2px, 2px 8px, 2px 8px",
};

export const eventTitle: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: 12,
  lineHeight: 1.2,
  overflow: "hidden",
};

export const eventLocationTime: CSSProperties = {
  fontFamily: fontFamilySans,
  marginTop: 4,
  fontSize: 12,
  width: 209,
  overflow: "hidden",
};

export const eventAPIcon: CSSProperties = {
  marginTop: -2,
  width: 18,
  height: 18,
};

export const simpleEvent: CSSProperties = {
  position: "absolute",
  minHeight: 24,
  borderRadius: 2,
  width: "100%",
  fontFamily: fontFamilySans,
  fontSize: "12px",
  lineHeight: "24px",
  padding: "0 9px",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  color: greys.white,
  zIndex: 11,
  transformOrigin: "center top",
  transition: "color 2s, background 2s, border 2s, opacity 2s, transform 2s",
};

export const styles = {
  event,
  eventDisabled,
  eventTitle,
  eventLocationTime,
  eventAPIcon,
  simpleEvent,
  tipHeader,
  tipBody,
  container: {
    transition: "height 250ms, width 250ms, left 250ms, top 250ms, z-index 250ms",
    position: "absolute",
    paddingBottom: 4,
    paddingLeft: 2,
    paddingRight: 2,
    zIndex: 1,
    "&:hover": {
      zIndex: 2,
    },
  } as CSSProperties,
  eventMask: {
    borderRadius: 8,
    height: "100%",
    width: "100%",
    backgroundColor: greys.white,
  } as CSSProperties,
};
